export default class FileLoader {
  fileType;
  loadFile(file, imageId) { }
  getDataset(image, imageId) { }
  getStudies(dataset, imageId) { }
}
